export enum ChallengeStatus {
    INCOMING,
    ONGOING,
    FINISHED
}
